import { Box, Typography } from "@mui/material";
import "../../styles/scss/PageHeader.scss";
import "../../styles/scss/Button.scss";

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  showSearch?: boolean;
  searchPlaceholder?: string;
  onSearchChange?: (value: string) => void;
  defaultSearchValue?: string;
  filters?: React.ReactNode;
  primaryButton?: {
    label: string;
    icon?: React.ReactNode;
    buttonLoading?: boolean;
    onClick: () => void;
  };
  secondaryButton?: {
    label: string;
    onClick: () => void;
  };
}

export default function PageHeader({
  title,
  subtitle,
  showSearch = false,
  searchPlaceholder = "Search...",
  onSearchChange,
  defaultSearchValue = "",
  filters,
  primaryButton,
  secondaryButton,
}: PageHeaderProps) {
  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    onSearchChange?.(e.target.value);
  };

  return (
    <Box className="page-header">
      <Box className="page-header-left">
        <Typography variant="h4" className="page-title">
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body2" className="page-subtitle">
            {subtitle}
          </Typography>
        )}
      </Box>
      
      <Box className="page-header-right">
        {filters}

        {showSearch && (
          <Box className="search-box">
            <span className="material-symbols-outlined">search</span>
            <input
              type="text"
              placeholder={searchPlaceholder}
              defaultValue={defaultSearchValue}
              onChange={handleSearch}
            />
          </Box>
        )}
        
        {secondaryButton && (
          <button 
            className="btn btn--secondary"
            onClick={secondaryButton.onClick}
          >
            {secondaryButton.label}
          </button>
        )}
        
        {primaryButton && (
          <button
            className={`btn btn--primary ${primaryButton?.buttonLoading ? 'btn-loading' : ''}`}
            onClick={primaryButton.onClick}
            disabled={primaryButton?.buttonLoading}
          >
            {primaryButton.icon}
            <span className="btn-content">{primaryButton.label}</span>
            {primaryButton?.buttonLoading && <span className="btn-spinner"></span>}
          </button>
        )}
      </Box>
    </Box>
  );
}
